/**
 * Simple Add to Cart
 * A minimal, standalone add-to-cart mechanism for product cards.
 * Deliberately avoids Shopify's {% form 'product' %} tag and Dawn's
 * quick-add/product-form markup, POSTing directly to /cart/add.js instead.
 * It still integrates with Dawn's native cart-notification popup so the
 * normal "item added to cart" UX keeps working.
 */
(function () {
  function getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function getSectionsToRender(cart) {
    if (cart && typeof cart.getSectionsToRender === 'function') {
      return cart.getSectionsToRender();
    }
    return [
      { id: 'cart-notification-product' },
      { id: 'cart-notification-button' },
      { id: 'cart-icon-bubble' }
    ];
  }

  function toggleLoading(button, isLoading) {
    var text = button.querySelector('.simple-atc-button__text');
    var spinner = button.querySelector('.simple-atc-button__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
    if (text) text.classList.toggle('hidden', isLoading);
    button.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
    button.disabled = isLoading || button.hasAttribute('data-sold-out');
  }

  function handleClick(event) {
    var button = event.target.closest('[data-simple-atc-button]');
    if (!button || button.disabled) return;

    event.preventDefault();

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var cart = getCart();
    toggleLoading(button, true);

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: getSectionsToRender(cart).map(function (section) { return section.id; }),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'simple-add-to-cart',
              productVariantId: variantId,
              errors: response.description,
              message: response.message
            });
          }
          console.error('Simple Add to Cart error:', response.description || response.message);
          return;
        }

        if (cart) {
          cart.renderContents(response);
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'simple-add-to-cart', productVariantId: variantId });
        }
      })
      .catch(function (error) {
        console.error('Simple Add to Cart error:', error);
      })
      .finally(function () {
        toggleLoading(button, false);
      });
  }

  document.addEventListener('click', handleClick);
})();
